import { sanitizeFetchType } from 'react-admin'
import { EngineDto } from '../../dto/device/engine/engine.dto'
import { ResourceName } from '../../ResourceName'
import {
  ToggleButtonAction,
  ToggleButtonState,
  ToggleType,
} from './engine-lock-button'
import { DateTime } from '../../common/date-time'

type Mutation = {
  type: string
  resource: string
  // eslint-disable-next-line @typescript-eslint/ban-types
  payload?: object
}

const lockMutation = (
  { id }: EngineDto,
  disabledId?: number,
  recurringJobName?: string,
  cronExpression?: string,
  scheduledAt?: DateTime,
): Mutation => ({
  type: sanitizeFetchType('lock'),
  resource: ResourceName.ENGINES,
  payload: {
    engineId: id,
    disabledId,
    recurringJobName,
    cronExpression,
    scheduledAt,
  },
})

const unlockMutation = (
  { id }: EngineDto,
  disabledId?: number,
  recurringJobName?: string,
  cronExpression?: string,
  scheduledAt?: DateTime,
): Mutation => ({
  type: sanitizeFetchType('unlock'),
  resource: ResourceName.ENGINES,
  payload: {
    engineId: id,
    recurringJobName,
    cronExpression,
    scheduledAt,
  },
})

type State = {
  mutateQuery?: (
    engine: EngineDto,
    disabledId?: number,
    recurringJobName?: string,
    cronExpression?: string,
    scheduledAt?: DateTime,
  ) => Mutation
} & ToggleButtonState

export const engineLockButtonInitialState = {
  type: ToggleType.UNLOCK,
  text: 'resources.engines.actions.unlock',
}

export const engineLockButtonReducer = (
  state: State,
  { type }: ToggleButtonAction,
): State => {
  switch (type) {
    case ToggleType.LOCK: {
      return {
        type,
        text: 'resources.engines.actions.lock',
        mutateQuery: lockMutation,
      }
    }
    case ToggleType.UNLOCK: {
      return {
        type,
        text: 'resources.engines.actions.unlock',
        mutateQuery: unlockMutation,
      }
    }
    default:
      throw new Error()
  }
}
